import type {Elements, IContentItem} from '@kontent-ai/delivery-sdk'
import type {Block} from '@/services/kontent-ai/types'
import {KontentResponsivePicture} from '@/products/flexible-web-toolkit/components/responsive-picture'
import {FullWidthCarousel} from '../../components/carousel/full-width-carousel'

export type FullWidthCarouselContentItem = IContentItem<{
	autoplay: Elements.MultipleChoiceElement
	images: Elements.AssetsElement
	mobileImage: Elements.AssetsElement
}>

export const FullWidthCarouselBlock: Block<FullWidthCarouselContentItem> = ({
	block,
}) => {
	const mobileImage = block.elements.mobileImage[0] ?? null
	const desktopImage = block.elements.images[0] ?? mobileImage

	return (
		<div data-kontent-element-codename={block.system.codename}>
			<FullWidthCarousel>
				<KontentResponsivePicture
					className="max-h-screen w-full object-cover"
					desktopAsset={desktopImage}
					fetchPriority="high"
					mobileAsset={mobileImage}
					quality={100}
					sizes="100vw"
				/>
			</FullWidthCarousel>
		</div>
	)
}
